import { MenuLinkModel, MenuLinkPayloadModel } from '../types/menuTypes';
import { LinkTypeEnum } from '../constants/menuConstants';

export const mockWardLinks: MenuLinkModel[] = [
  {
    id: 1,
    name: 'UPWARD',
    nameTranslations: [
      { culture: 'en', value: 'UPWARD' },
      { culture: 'fr', value: 'UPWARD' },
    ],
    idModuleWard: 1,
    inHeader: true,
    forMobile: false,
    linkType: LinkTypeEnum.Ward,
    url: '/upward',
    order: 1,
    hidden: false,
  },
  {
    id: 2,
    name: 'Mes Notes',
    nameTranslations: [
      { culture: 'en', value: 'My Grades' },
      { culture: 'fr', value: 'Mes Notes' },
    ],
    idModuleWard: 1,
    inHeader: false,
    forMobile: true,
    linkType: LinkTypeEnum.Ward,
    url: '/notes',
    order: 2,
    hidden: false,
  },
  {
    id: 3,
    name: 'Agenda',
    nameTranslations: [
      { culture: 'en', value: 'Agenda' },
      { culture: 'fr', value: 'Agenda' },
    ],
    idModuleWard: 1,
    inHeader: false,
    forMobile: false,
    linkType: LinkTypeEnum.Ward,
    url: '/agenda',
    order: 3,
    hidden: false,
  },
  {
    id: 4,
    name: 'Les Stages',
    nameTranslations: [
      { culture: 'en', value: 'Internships' },
      { culture: 'fr', value: 'Les Stages' },
    ],
    idModuleWard: 2,
    inHeader: true,
    forMobile: false,
    linkType: LinkTypeEnum.Ward,
    url: '/stages',
    order: 1,
    hidden: false,
  },
  {
    id: 5,
    name: 'JobTeaser',
    nameTranslations: [
      { culture: 'en', value: 'JobTeaser' },
      { culture: 'fr', value: 'JobTeaser' },
    ],
    idModuleWard: 2,
    inHeader: false,
    forMobile: true,
    linkType: LinkTypeEnum.External,
    url: 'https://jobteaser.com',
    order: 2,
    hidden: false,
  },
  {
    id: 6,
    name: 'Documents Administratifs',
    nameTranslations: [
      { culture: 'en', value: 'Administrative Documents' },
      { culture: 'fr', value: 'Documents Administratifs' },
    ],
    idModuleWard: 3,
    inHeader: true,
    forMobile: false,
    linkType: LinkTypeEnum.Ward,
    url: '/documents',
    order: 1,
    hidden: false,
  },
  {
    id: 7,
    name: 'Vie Pratique',
    nameTranslations: [
      { culture: 'en', value: 'Practical Life' },
      { culture: 'fr', value: 'Vie Pratique' },
    ],
    idModuleWard: 4,
    inHeader: true,
    forMobile: false,
    linkType: LinkTypeEnum.Ward,
    url: '/vie-pratique',
    order: 1,
    hidden: false,
  },
];

export class MockWardLinksManagementService {
  static async getLinks(): Promise<MenuLinkModel[]> {
    // Simulate a delay to mimic an API call
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(mockWardLinks);
      }, 1000);
    });
  }

  static async createLink(newLink: MenuLinkPayloadModel): Promise<MenuLinkModel> {
    // Simulate a delay to mimic an API call
    return new Promise((resolve) => {
      setTimeout(() => {
        const id = mockWardLinks.length ? Math.max(...mockWardLinks.map((l) => l.id)) + 1 : 1;
        const newLinkWithId: MenuLinkModel = {
          ...newLink,
          id: id,
        };
        mockWardLinks.push(newLinkWithId);
        resolve(newLinkWithId);
      }, 1000);
    });
  }

  static async updateLink(updatedLink: MenuLinkModel): Promise<MenuLinkModel> {
    // Simulate a delay to mimic an API call
    return new Promise((resolve) => {
      setTimeout(() => {
        const index = mockWardLinks.findIndex((link) => link.id === updatedLink.id);
        if (index !== -1) {
          mockWardLinks[index] = updatedLink;
          resolve(updatedLink);
        } else {
          throw new Error('Link not found');
        }
      }, 1000);
    });
  }

  static async deleteLink(id: number): Promise<void> {
    // Simulate a delay to mimic an API call
    return new Promise((resolve) => {
      setTimeout(() => {
        const index = mockWardLinks.findIndex((link) => link.id === id);
        if (index !== -1) {
          mockWardLinks.splice(index, 1);
          resolve();
        } else {
          throw new Error('Link not found');
        }
      }, 1000);
    });
  }
}
